(function () {
  'use strict';

  // Activamos las animaciones de entrada solo si este archivo se ha cargado y
  // el navegador sabe detectar cuándo un elemento entra en pantalla. Si algo
  // falla, la clase no se añade y la página se ve entera desde el principio.
  if ('IntersectionObserver' in window) {
    document.documentElement.classList.add('mt-anim');
  }

  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mt-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );
    els.forEach(function (el) { observer.observe(el); });

    // Red de seguridad: si la pestaña está en segundo plano o el observador no
    // llega a dispararse, mostramos todo igualmente pasados unos segundos.
    function mostrarTodo() {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
    }
    if (document.hidden) { mostrarTodo(); }
    setTimeout(mostrarTodo, 3000);
  }

  function initGaleriaProducto() {
    var secciones = document.querySelectorAll('[data-mt-galeria]');
    secciones.forEach(function (galeria) {
      var principal = galeria.querySelector('[data-mt-galeria-principal]');
      var minis = galeria.querySelectorAll('[data-mt-galeria-mini]');
      if (!principal || !minis.length) return;
      minis.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var src = mini.getAttribute('data-full');
          var alt = mini.getAttribute('data-alt') || '';
          var img = principal.querySelector('img');
          if (img && src) {
            img.src = src;
            img.alt = alt;
          }
          minis.forEach(function (m) { m.classList.remove('mt-activa'); });
          mini.classList.add('mt-activa');
        });
      });
    });
  }

  function initProductoVariantes() {
    var forms = document.querySelectorAll('[data-mt-producto-form]');
    forms.forEach(function (form) {
      var dataEl = form.querySelector('[data-mt-variantes-json]');
      if (!dataEl) return;
      var variantes;
      try {
        variantes = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }

      var pildoraGrupos = form.querySelectorAll('[data-mt-opcion]');
      var inputId = form.querySelector('[data-mt-variant-id]');
      var precioEl = form.querySelector('[data-mt-precio]');
      var precioAntesEl = form.querySelector('[data-mt-precio-antes]');
      var btnAdd = form.querySelector('[data-mt-add]');
      var btnTexto = btnAdd ? btnAdd.querySelector('[data-mt-add-texto]') : null;

      function opcionesSeleccionadas() {
        var seleccion = [];
        pildoraGrupos.forEach(function (grupo) {
          var activa = grupo.querySelector('.mt-activa');
          seleccion.push(activa ? activa.getAttribute('data-valor') : null);
        });
        return seleccion;
      }

      function encontrarVariante() {
        var seleccion = opcionesSeleccionadas();
        return variantes.find(function (v) {
          return v.options.every(function (val, i) { return val === seleccion[i]; });
        });
      }

      var moneda = form.getAttribute('data-currency') || 'USD';
      var formateador;
      try {
        formateador = new Intl.NumberFormat('en-US', { style: 'currency', currency: moneda });
      } catch (e) {
        formateador = null;
      }

      function formatearDinero(centavos) {
        var monto = centavos / 100;
        if (formateador) return formateador.format(monto);
        return moneda + ' ' + monto.toFixed(2);
      }

      function actualizar() {
        var variante = encontrarVariante();
        if (!variante) return;
        if (inputId) inputId.value = variante.id;
        if (precioEl) precioEl.textContent = formatearDinero(variante.price);
        if (precioAntesEl) {
          if (variante.compare_at_price && variante.compare_at_price > variante.price) {
            precioAntesEl.textContent = formatearDinero(variante.compare_at_price);
            precioAntesEl.style.display = '';
          } else {
            precioAntesEl.style.display = 'none';
          }
        }
        if (btnAdd) {
          btnAdd.disabled = !variante.available;
          if (btnTexto) btnTexto.textContent = variante.available ? btnTexto.getAttribute('data-texto-normal') : btnTexto.getAttribute('data-texto-agotado');
        }

        pildoraGrupos.forEach(function (grupo, i) {
          var pildoras = grupo.querySelectorAll('[data-mt-pildora]');
          pildoras.forEach(function (pildora) {
            var valor = pildora.getAttribute('data-valor');
            var seleccionPrueba = opcionesSeleccionadas().slice();
            seleccionPrueba[i] = valor;
            var existe = variantes.some(function (v) {
              return v.options.every(function (val, j) { return val === seleccionPrueba[j]; });
            });
            pildora.disabled = !existe;
          });
        });
      }

      pildoraGrupos.forEach(function (grupo) {
        var pildoras = grupo.querySelectorAll('[data-mt-pildora]');
        pildoras.forEach(function (pildora) {
          pildora.addEventListener('click', function () {
            if (pildora.disabled) return;
            pildoras.forEach(function (p) { p.classList.remove('mt-activa'); });
            pildora.classList.add('mt-activa');
            actualizar();
          });
        });
      });

      var cantidadInput = form.querySelector('[data-mt-cantidad-input]');
      var cantidadMas = form.querySelector('[data-mt-cantidad-mas]');
      var cantidadMenos = form.querySelector('[data-mt-cantidad-menos]');
      if (cantidadMas && cantidadInput) {
        cantidadMas.addEventListener('click', function () {
          cantidadInput.value = Math.max(1, parseInt(cantidadInput.value || '1', 10) + 1);
        });
      }
      if (cantidadMenos && cantidadInput) {
        cantidadMenos.addEventListener('click', function () {
          cantidadInput.value = Math.max(1, parseInt(cantidadInput.value || '1', 10) - 1);
        });
      }

      actualizar();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initGaleriaProducto();
    initProductoVariantes();
  });
})();
